module.exports = __webpack_public_path__ + "img/7_175.9b976a42.png";